import React, { ReactNode } from 'react'
import ButtonX from '../assets/buttonX.svg'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#000000]/30 bg-opacity-35 backdrop-blur z-50">
      <div className="flex flex-col items-center rounded-[30px] p-6 w-full max-w-lg mx-4  relative bg-[#3C4047] ">
        
        <div>{children}</div>
        <img onClick={onClose} className=' cursor-pointer' src={ButtonX} width={44} height={44} alt='Fermer la modale exemple facture'/>
      </div>
    </div>
  )
}

export default Modal
